module.exports = __webpack_public_path__ + "static/media/viraj_jadhav.e9297140.jpg";